import clsx from 'clsx';
import React from 'react';

// Needed to properly initialize sidebars
import '@eleveo/foundation/lib/components/scrollbar.css';

// @ts-expect-error: it's there
import styles from '../../styles/index.new.scss';
import { DrawerSideBox } from '../Drawer/DrawerSideBox';
import { Navigation } from '../layout/Navigation/Navigation';
import { LayoutWrapper, NavigationWrapper } from './LayoutNext';
import { useLayout } from './LayoutProvider';

import type { LayoutProps } from './LayoutNext';

export const Layout = ({ children }: LayoutProps) => {
  const { nav } = useLayout();

  React.useEffect(() => {
    styles?.use?.(); // Keep this as optional to unblock test runner

    return () => {
      styles?.unuse?.(); // Keep this as optional to unblock test runner
    };
  }, []);

  return (
    <LayoutWrapper>
      <NavigationWrapper>
        {/* This will be changed once all scenes are migrated or Hybrid Navigation is in place. */}
        <div className={clsx('layout__navigation', { collapsed: !nav.isOpen, collapsing: nav.isAnimating })}>
          <DrawerSideBox toggleDrawer={nav.toggle}>
            <Navigation isDrawerOpen={nav.isOpen} />
          </DrawerSideBox>
        </div>
      </NavigationWrapper>

      {children}
    </LayoutWrapper>
  );
};
